import {options} from "pages/NurseOut/ExamHistory/config";
import {useState} from "react";
import {FIELD_TYPE, FORMAT_TIME} from "types/enums";
import {DataFormField} from "types/models/input-field-type";
const {
  INPUT,
  SELECT,
  TEXT_AREA,
  DATE,
  COLOR,
  COMBO_BOX,
  TIME,
  NUMBER,
  DATE_DISABLE_NO_DAY,
} = FIELD_TYPE;
const css = {xs: 24, sm: 24, md: 24, lg: 8, xl: 8};
const dataFields: DataFormField[] = [
  {
    type: INPUT,
    label: "Số ký hiệu văn bản",
    name: "soHieu",
    disable: false,
    expand: false,
    // rules: [{ required: true, message: "Chưa nhập loại công việc" }],
    css: css,
    wrapperCol: {xs: 24, sm: 14, md: 16, lg: 14, xl: 14},
    labelCol: {xs: 24, sm: 10, md: 8, lg: 10, xl: 10},
  },
  {
    type: DATE,
    label: "Ngày tháng của văn bản",
    name: "ngayThangNamVanBan",
    expand: true,
    // rules: [{ required: true, message: "Chưa nhập thời gian bắt đầu" }],
    // optionsTime: {
    //   showTime: true,
    //   format: FORMAT_TIME.time_24h,
    // },
    css: css,
    wrapperCol: {xs: 24, sm: 14, md: 16, lg: 14, xl: 14},
    labelCol: {xs: 24, sm: 10, md: 8, lg: 10, xl: 10},
    disableDate: false,
    optionsTime: {showTime: true, format: FORMAT_TIME.dayFull},
  },
  {
    type: TEXT_AREA,
    label: "Tên loại và trích yếu nội dung văn bản",
    name: "tenLoaiVaTrichYeu",
    disable: false,
    hide: false,
    // rules: [{ required: true, message: "Chưa nhập thời gian đi muộn" }],
    css: css,
    wrapperCol: {xs: 24, sm: 14, md: 16, lg: 14, xl: 14},
    labelCol: {xs: 24, sm: 10, md: 8, lg: 10, xl: 10},
  },
  {
    type: INPUT,
    label: "Người ký",
    hide: false,
    name: "nguoiKy",
    css: css,
    wrapperCol: {xs: 24, sm: 14, md: 16, lg: 14, xl: 14},
    labelCol: {xs: 24, sm: 10, md: 8, lg: 10, xl: 10},
  },
  {
    type: INPUT,
    label: "Đơn vị hoặc người nhận bản lưu",
    name: "noiNhan",
    // rules: [{ required: true, message: "Chưa nhập thời gian kết thúc" }],
    disable: false,
    hide: false,
    css: css,
    wrapperCol: {xs: 24, sm: 14, md: 16, lg: 14, xl: 14},
    labelCol: {xs: 24, sm: 10, md: 8, lg: 10, xl: 10},
  },
  {
    type: INPUT,
    label: "Số lượng bản",
    name: "soLuong",
    hide: false,
            rules: [
        {
            pattern: /^[0-9]*$/, // Quy tắc để chỉ cho phép nhập số
            message: "Chỉ cho phép nhập số"
        }],
    css: css,
    wrapperCol: {xs: 24, sm: 14, md: 16, lg: 14, xl: 14},
    labelCol: {xs: 24, sm: 10, md: 8, lg: 10, xl: 10},
    disable: false,
  },

  {
    type: INPUT,
    label: "Ghi chú",
    name: "ghiChu",
    hide: false,
    css: css,
    wrapperCol: {xs: 24, sm: 14, md: 16, lg: 14, xl: 14},
    labelCol: {xs: 24, sm: 10, md: 8, lg: 10, xl: 10},
  },
];
export {dataFields};
